import React from "react";
import Lottie from "lottie-react";
import timeAnimation3 from "./analytics.json"; // Asegúrate de que el archivo JSON esté en la misma carpeta

const TimeAnimation = () => {
  return <Lottie animationData={timeAnimation3} loop={true} style={{ width: 200, height: 200 }} />;
};

export default TimeAnimation;
